import React from 'react';
import { Wrapper, Status } from '@googlemaps/react-wrapper';

interface GoogleMapsWrapperProps {
  children: React.ReactNode;
  render?: (status: Status) => React.ReactElement;
}

const defaultRender = (status: Status) => {
  if (status === Status.FAILURE) {
    return (
      <div className="w-full h-64 bg-red-50 border border-red-200 rounded-lg flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 font-medium">Failed to load Google Maps</p>
          <p className="text-red-500 text-sm mt-1">Please check your internet connection</p>
        </div>
      </div>
    );
  }

  if (status === Status.LOADING) {
    return (
      <div className="w-full h-64 bg-gray-50 border border-gray-200 rounded-lg flex items-center justify-center">
        <div className="flex items-center">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-emerald-600 mr-2"></div>
          Loading Google Maps...
        </div>
      </div>
    );
  }

  return <></>;
};

const GoogleMapsWrapper: React.FC<GoogleMapsWrapperProps> = ({
  children,
  render = defaultRender
}) => {
  return (
    <Wrapper
      apiKey="AIzaSyDngO2LnuSe_CQ7b6W7dbbtByh16aEAaek"
      render={render}
      libraries={['places']}
    >
      {children}
    </Wrapper>
  );
};

export default GoogleMapsWrapper;